
import React from "react";
import firebase from "firebase/compat/app";

export type AuthContextType = {
	user: firebase.User | null;
	isAdmin: boolean;
};

export const AuthContext = React.createContext<AuthContextType>({
	user: null,
	isAdmin: false,
});
